(function() {
  'use strict';
  
  function initComparisonSection() {
    const data = window.comparisonSectionData;
    if (!data) return;
    
    const section = document.querySelector('[data-section-id="' + data.sectionId + '"]');
    if (!section) return;

    const toggleBtn = section.querySelector('[data-toggle-comparison]');
    const transitionElements = section.querySelectorAll('[data-transition]');
    const productImages = section.querySelectorAll('.comparison-product__img');
    const bgImages = section.querySelectorAll('.comparison-bg-image');
    const mobileBgImages = section.querySelectorAll('.comparison-bg-image--mobile');
    
    if (!toggleBtn) return;

    // Initialize underscore position
    const activeUnderscore = section.querySelector('.comparison-title__active-underscore');
    const initialTitle = section.querySelector('.comparison-title__aura');
    if (activeUnderscore && initialTitle) {
      const titleRect = initialTitle.getBoundingClientRect();
      activeUnderscore.style.width = `${titleRect.width}px`;
      activeUnderscore.style.left = `${initialTitle.offsetLeft}px`;
      activeUnderscore.style.backgroundColor = '#fff8e7';
    }

    toggleBtn.addEventListener('click', function() {
      const currentState = section.dataset.state;
      const newState = currentState === 'others' ? 'aura' : 'others';
      
      // Fade out
      section.classList.add('transitioning');
      
      setTimeout(function() {
        // Update state
        section.dataset.state = newState;
        
        // Update background color
        section.style.backgroundColor = data[newState].bgColor;
        
        // Update subtitle
        const subtitle = section.querySelector('.comparison-subtitle-top');
        if (subtitle) subtitle.textContent = data[newState].subtitle;
        
        // Toggle title underline
        const othersTitle = section.querySelector('.comparison-title__others');
        const auraTitle = section.querySelector('.comparison-title__aura');

        // move .comparison-title__active-underscore line to next state
        const activeUnderscore = section.querySelector('.comparison-title__active-underscore');
        const targetTitle = newState === 'others' ? othersTitle : auraTitle;
        
        // Position the underscore under the target title
        if (activeUnderscore && targetTitle) {
          const titleRect = targetTitle.getBoundingClientRect();
          activeUnderscore.style.width = `${titleRect.width}px`;
          activeUnderscore.style.left = `${targetTitle.offsetLeft}px`;
          activeUnderscore.style.backgroundColor = targetTitle === othersTitle ? '#2b2b2b' : '#fff8e7';
        }

        if (newState === 'others') {
          if (othersTitle) othersTitle.classList.add('active');
          if (auraTitle) auraTitle.classList.remove('active');
        } else {
          if (othersTitle) othersTitle.classList.remove('active');
          if (auraTitle) auraTitle.classList.add('active');
        }
        
        // Update all text elements
        transitionElements.forEach(function(el) {
          const othersText = el.dataset.othersText;
          const auraText = el.dataset.auraText;
          const newText = newState === 'others' ? othersText : auraText;
          
          if (newText && newText !== 'undefined' && newText !== '') {
            el.textContent = newText;
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
        
        // Toggle product images
        productImages.forEach(function(img) {
          if (img.classList.contains('comparison-product__img--' + newState)) {
            img.classList.add('active');
          } else {
            img.classList.remove('active');
          }
        });
        
        // Toggle background images
        bgImages.forEach(function(bgImg) {
          if (bgImg.classList.contains('comparison-bg-image--' + newState)) {
            bgImg.classList.add('active');
          } else {
            bgImg.classList.remove('active');
          }
        });
        
        // Toggle background images (mobile)
        mobileBgImages.forEach(function(bgImg) {
          if (bgImg.classList.contains('comparison-bg-image--' + newState)) {
            bgImg.classList.add('active');
          } else {
            bgImg.classList.remove('active');
          }
        });
        
        // Fade in
        setTimeout(function() {
          section.classList.remove('transitioning');
        }, 50);
        
      }, 300);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComparisonSection);
  } else {
    initComparisonSection();
  }
})();
